import api from "@/network";
import { generateId, } from '@/services/Mathe';
import { taskSingleAdapter } from '@/adapters/assessmentPlans/tasks/tasks.adapter';
import { makeMarkItem, scaleIndexAdapter } from '@/adapters/assessmentPlans/tasks/customAssessment.adapter';
import useToast from "@/components/UI/AppToast/useToast";
import CustomAssessmentApi from "@/api/custom-assessment.api";

const fetchBasicTask = async (payload) => {
    return await api.get(`plans/${ payload.uuidPlan }/tests/${ payload.uuid }`);
}

export default {
    state: {
        mark: null,
        sessionUuid: '',
        expRespTask: null,
        task: {
            parameters: {
                param_type: ''
            },
            files: [],
            files_expert: [],
            mainTest: {
                TestTitle: ''
            }
        },
        scales: [],
        marksChanged: false
    },

    getters: {
        task(state) {
            return state.task;
        }
    },

    actions: {
        async fetchTask({commit}, payload = {}) {
            const response = await fetchBasicTask(payload);
            commit('updateStore', {
                entity: 'task',
                payload: response.data.data,
            });
            return response;
        },

        async startTaskSession({}, {planUuid, taskUuid, testName}) {
            const query = testName ? `?testName=${testName}` : '';
            return await api.post(`plans/${planUuid}/tests/${taskUuid}/session${query}`);
        },
        async confirmTask({commit}, {planUuid, test}) {
            return await api.post(`plans/${planUuid}/tests/${test.uuid}/confirm`)
                .then(() => {
                    commit('assessmentPlans/plan/moveTestToFinished', test, {root: true});
                });
        }
    },

    mutations: {
        updateMark(state, newMark) {
            if(!newMark) {
                state.mark = null
            } else {
                newMark.scales.forEach(scale => {
                    let foundScale = state.scales.find(item => scale.name === item.name);
                    if (!foundScale) return;

                    foundScale.value = scale.value;

                });
            }
            state.mark = newMark;

        },
        updateStore(state, { entity, payload }) {
            state[entity] = payload;
        },
        updateMarksChanged(state, value) {
            state.marksChanged = value;
        }
    },
}